import type { Project } from "../../lib/projects";

type ProjectStatusBadgesProps = {
  project: Project;
  className?: string;
  /** When false, hides the “Current” badge (e.g. on ux-portfolio). */
  showCurrent?: boolean;
};

/** Overlay badges for portfolio cards (own product vs client work). */
export function ProjectStatusBadges({
  project,
  className = "absolute top-4 left-4 flex flex-col gap-1.5 z-10",
  showCurrent = true,
}: ProjectStatusBadgesProps): JSX.Element | null {
  if (!project.own && !(project.current && showCurrent)) return null;

  return (
    <div className={className}>
      {project.own && (
        <span className="inline-block bg-amber-500 text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide shadow-sm">
          My project
        </span>
      )}
      {project.current && showCurrent && (
        <span className="inline-block bg-wwwuxmichalcomdodger-blue text-white px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide shadow-sm">
          Current
        </span>
      )}
    </div>
  );
}
